import * as actionTypes from "./action_types";
import {sixYardAxios} from "../../sixYardAxios";
import qs from "qs";
import { fetchUserInfoSuccess } from "./profile";

const translations = {
  errors: {
    loginCancelled: {
      en: 'Login cancelled - Please try again',
      ar: 'تم إلغاء تسجيل الدخول - يرجى المحاولة مرة أخرى'
    },
    popupBlocked: {
      en: 'Popup blocked - Please allow popups for this website',
      ar: 'تم حظر النافذة المنبثقة - يرجى السماح بالنوافذ المنبثقة لهذا الموقع'
    },
    loginInProgress: {
      en: 'Another login is in progress',
      ar: 'هناك عملية تسجيل دخول أخرى قيد التنفيذ'
    },
    unauthorizedDomain: {
      en: 'This domain is not authorized for login',
      ar: 'هذا النطاق غير مصرح به لتسجيل الدخول'
    },
    defaultError: {
      en: 'Something went wrong. Please try again.',
      ar: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.'
    }
  }
};

export const authStart = email => {
  return {
    type: actionTypes.AUTH_START,
    email
  };
};

export const authSuccess = (authData, userData , message) => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    authData: authData, 
    user: userData,
    message : message,
  };
};

export const clearError = () => {
  return {
    type: actionTypes.CLEAR_AUTH_ERROR
  };
};

export const clearMessage = () => {
  return {
    type: actionTypes.CLEAR_AUTH_MESSAGE
  };
};

export const changePasswordStart = email => {
  return {
    type: actionTypes.CHANGE_PASSWORD_START,
    email
  };
};
export const changePasswordSuccess = (/*authData, userData ,*/ message) => {
  return {
    type: actionTypes.CHANGE_PASSWORD_SUCCESS,
    // authData: authData, 
    // user: userData,
    message : message,
  };
};
// export const facebookAuthFail = error => {
//   return {
//     type: actionTypes.FACEBOOK_AUTH_FAILED,
//     error
//   };
// };

// export const googleAuthFail = error => {
//   return {
//     type: actionTypes.GOOGLE_AUTH_FAILED,
//     error
//   };
// };

// export const facebookAuth = facebookData => {
//   return (dispatch, getState) => {
//     const state=getState();
//     const language = state.home.selected_language === 1 ? "en" : "ar";
//     const user = {
//       email: facebookData?.email,
//       first_name: facebookData?.name?.split(" ")[0],
//       last_name: facebookData?.name?.split(" ")[1],
//       image_path: facebookData?.picture?.data.url
//     };

//     // send auth API to login with the server
//     const provider = "facebook";
//     const email = user.email;
//     const name = facebookData?.name;
//     const token = facebookData?.accessToken;

//     sixYardAxios
//       .post("/login/social", qs.stringify({ email, provider, name, token }))
//       .then(res => {
//         const expirationDate =  res.data.data.expires_in;
//         const token = res.data.data.access_token;
//         localStorage.setItem("isVerified", res.data.data.student.is_verified);
//         localStorage.setItem("token", token);
//         Cookies.set("token", token);
//         localStorage.setItem("expirationDate", expirationDate);
//         localStorage.setItem("user", JSON.stringify(user));
//         dispatch(authSuccess({ access_token: token }, user), res.data.message);
//         afterAuthSucess(
//           res.data.data.access_token,
//           expirationDate,
//           user,
//           res.data.data.expires_in,
//           res.data.data,
//           dispatch,
//           res.data.message
//         );
//         // check if we should divide time by 1000
//         dispatch(checkAuthTimeout((Date.parse(expirationDate))));
//       })
//       .catch(err => {
//         dispatch(facebookAuthFail(err.response.data));
//       });
//   };
// };
// export const googleAuth = googleData => {
//   return (dispatch, getState) => {
//     const state=getState();
//     const language = state.home.selected_language === 1 ? "en" : "ar";
//     const campaign_token = storage?.getItem("URLToken") && storage.getItem("URLToken");
//     const reqBody = {};
//     let token = "";

//     reqBody.provider = "google";
//     if (!googleData.credential) {
//       reqBody.email = googleData?.profileObj?.email;
//       reqBody.name =
//           googleData?.profileObj?.givenName + " " + googleData?.profileObj?.familyName;
//       token = googleData?.tokenObj?.access_token;
//     } else {
//       token = googleData?.credential;
//       reqBody.is_one_tap = 1;
//     }
//     reqBody.token = token;
//     reqBody.web_token = localStorage.getItem("fcm_token");
//     reqBody.campaign_token = campaign_token;

//     sixYardAxios
//       .post("/login/social?language="+language, qs.stringify(reqBody))
//       .then(res => {
//         const expirationDate =  res.data.data.expires_in;
//         const user = {
//           email: res.data.data.student.email,
//           first_name: res.data.data.student.first_name,
//           last_name: res.data.data.student.last_name,
//           image_path: res.data.data.student.image_path
//         };
//         localStorage.setItem("isVerified", res.data.data.student.is_verified);
//         localStorage.setItem("token", res.data.data.access_token);
//         Cookies.set("token", res.data.data.access_token);
//         localStorage.setItem("expirationDate", expirationDate);
//         localStorage.setItem("user", JSON.stringify(user));

//         dispatch(
//           authSuccess({ access_token: res.data.data.access_token }, user , res.data.message)
//         );
//         afterAuthSucess(
//           res.data.data.access_token,
//           expirationDate,
//           user,
//           res.data.data.expires_in,
//           res.data.data,
//           dispatch,
//           res.data.message
//         );
//         dispatch(checkAuthTimeout(Date.parse(expirationDate)));
//       }).catch(err => {
//       dispatch(googleAuthFail(err.response.data));
//     });
//   };
// };


export const authFail = error => {
  const language = parseInt(localStorage.getItem('language')) === 1 ? 'en' : 'ar';
  return {
    type: actionTypes.AUTH_FAIL,
    error: {
      ...error,
      message: error.message || translations.errors.defaultError[language]
    }
  };
};
export const changePasswordFail = error => {
  const language = parseInt(localStorage.getItem('language')) === 1 ? 'en' : 'ar';
  return {
    type: actionTypes.CHANGE_PASSWORD_FAILED,
    error: error || translations.errors.defaultError[language]
  };
};
export const registerSuccess = (registerData, userData, message) => {
  return {
    type: actionTypes.REGISTER_SUCCESS,
    registerData: registerData,
    user: userData,
    message: message
  };
};

export const registerFail = error => {
  const language = parseInt(localStorage.getItem('language')) === 1 ? 'en' : 'ar';
  return {
    type: actionTypes.REGISTER_FAIL,
    error: error?.response?.data || { message: translations.errors.defaultError[language] }
  };
};

export const sendLogoutAction=()=>{
  return {
    type: actionTypes.AUTH_LOGOUT
  };
};

export const logout = () => {
  return dispatch=>{
    localStorage.removeItem("token");
    localStorage.removeItem("user");
   dispatch(fetchUserInfoSuccess({}))
   dispatch(sendLogoutAction())    
  }
 
};
export const checkAuthTimeout = expirationTime => {
  return dispatch => {
    setTimeout(() => dispatch(logout()), expirationTime - Date.now());
  };
};

export const auth = (email,password) => {
  return dispatch => {
    dispatch(authStart(email));
    sixYardAxios
      .post("/auth/login", qs.stringify({ email, password }))
      .then(res => {        
        const user = res.data.data.user;
        afterAuthSucess(
          res.data.data.token,
          user,
          res.data.data,
          dispatch,
          res.data.message
        );
      })
      .catch(err => {        
        dispatch(authFail(err.response.data));
      });
  };
};

export const register = (
  email,
  password,
) => {
  return (dispatch, getState) => {
    dispatch(registerStart());
    sixYardAxios
      .post(
        "/auth/register",
        qs.stringify({
          email,
          password,
        }))
      .then(res => {
        const user = res.data.data.user;
        dispatch(registerSuccess(res.data.data, user, res.data.message));
      })
      .catch(err => {
        dispatch(registerFail(err));
      });
  };
};
export const changePassword = (current_password,new_password, new_password_confirmation) => {
  return dispatch => {
    // dispatch(changePasswordStart(email));
    sixYardAxios
      .put("/profile/change-password", qs.stringify({current_password,new_password, new_password_confirmation }))
      .then(res => {
        // const user = res.data.data.user;
        afterChangePasswordSucess(
          // res.data.data.token,
          // user,
          // res.data.data,
          dispatch,
          res.data.message
        );
      })
      .catch(err => {
        dispatch(changePasswordFail(err.response.data.message));
      });
  };
};
// export const resend = ()=>{
//   return (dispatch, getState)=>{
//     const state=getState();
//     const language = state.home.selected_language === 1 ? "en" : "ar";
//     dispatch(resendStart())
//     sixYardAxios.get('/student/resend?language='+language)
//     .then(res=>{
//       dispatch(vertificationSentSuccess())
//     })
//   }
// }
// const resendStart=()=>({
//   type:actionTypes.VERTIFICATION_SEND_START
// })
// const vertificationSentSuccess=()=>({
// type:actionTypes.VERTIFICATION_SENT
// })
const afterAuthSucess = (
  token,
  user,
  authData,
  dispatch,
  message
) => {
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user));
  dispatch(authSuccess(authData, user, message));
};
const afterChangePasswordSucess = (
  // token,
  // user,
  // authData,
  dispatch,
  message
) => {
  // localStorage.setItem("token", token);
  // localStorage.setItem("user", JSON.stringify(user));
  dispatch(changePasswordSuccess(/*authData, user,*/ message));
};
const AfterRegisterSuccess = (
  token,
  user,
  registerData,
  message,
  dispatch
) => {
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user));
  dispatch(registerSuccess(registerData, user, message));
};
export const registerStart = () => {
  return {
    type: actionTypes.REGISTER_START
  };
};
export const startForgetPassword = () => {
  return {
    type: actionTypes.START_FORGET_PASSWORD
  };
};
export const forgetPassword = email => {
  return (dispatch, getState) => {
    // const state=getState();
    // const language = state.home.selected_language === 1 ? "en" : "ar";
    sixYardAxios
      .post("/auth/forgot-password", qs.stringify({ email }))
      .then(res => {
        dispatch(forgetSuccess(email));
      })
      .catch(error => {
        dispatch(forgetFailed(error.response.data));
      });
  };
};
export const forgetSuccess = email => {
  return {
    type: actionTypes.FORGET_PASSWORD_EMAIL_SENT,
    email
  };
};
export const forgetFailed = error => {
  return {
    type: actionTypes.FORGET_PASSWORD_FAILED,
    error
  };
};
export const resetPassword = (email, password, verification_code) => {
  return (dispatch, getState) => {
    const state=getState();
    const language = state.home.selected_language === 1 ? "en" : "ar";
    sixYardAxios
      .post(
        "/reset-password?language="+language,
        qs.stringify({ email, password, verification_code }))
      .then(res => {
        if (res.data.status) {
          dispatch(resetSuccess(res.data.message));
          const user = res.data.data.user;
          const token = res.data.data.token;
          localStorage.setItem("token", token);
          localStorage.setItem("user", JSON.stringify(user));
          dispatch(authSuccess(token, user, res.data.message));
          afterAuthSucess(
            res.data.data.token,
            user,
            res.data.data,
            dispatch,
            res.data.message
          );
        } else {
          dispatch(resetFailed(res.data.message));
        }
      })
      .catch(error => {
        dispatch(resetFailed(error));
      });
  };
};
export const resetFailed = error => {
  return {
    type: actionTypes.RESET_PASSWORD_FAILED,
    error
  };
};
export const resetSuccess = (message) => {
  return {
    type: actionTypes.RESET_PASSWORD_SUCCESS,
    message:message
  };
};

export const authCheckState = () => {
  return dispatch => {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user"));
    
    if (!token) {
      dispatch(logout());
    } else {
      // Create auth data without the success message
      const authData = { token: token };
      
      // First, clear any existing messages
      dispatch(clearMessage());
      
      // Then restore auth state without messages
      dispatch({
        type: actionTypes.AUTH_SUCCESS,
        authData: authData,
        user: user,
        // Explicitly set message to null
        message: null
      });
    }
    return Promise.resolve();
  };
};

export const socialAuth = (provider, token) => {
  return dispatch => {
    dispatch(authStart());
    
    sixYardAxios.post('/auth/social-login', qs.stringify({
      provider,
      token
    }))
    .then(res => {
      const user = res.data.data.user;
      afterAuthSucess(
        res.data.data.token,
        user,
        res.data.data,
        dispatch,
        res.data.message
      );
    })
    .catch(err => {
      dispatch(authFail(err.response.data));
    });
  };
};
